import { render, staticRenderFns } from "./journeyConditionEditor.vue?vue&type=template&id=887b0576&scoped=true&"
import script from "./journeyConditionEditor.vue?vue&type=script&lang=js&"
export * from "./journeyConditionEditor.vue?vue&type=script&lang=js&"
import style0 from "./journeyConditionEditor.vue?vue&type=style&index=0&id=887b0576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887b0576",
  null
  
)

export default component.exports